import { useCallback } from 'react';
import uuid from 'react-uuid';
import { api } from 'src/constants/apiRoutes';
import useAsync from 'src/hooks/useAsync';
import { IPostBody } from 'src/types/PostBody';
import { ScanManagerInvoiceItem } from 'src/types/ScanManagerInvoices';
import axiosInstance from 'src/utils/axios';

interface AttachDocumentRequest {
  body: IPostBody;
  companyId: string;
  isInvoices: boolean;
  uploadsOlderThan90Days?: boolean;
}

interface AttachDocumentResponse {
  totalRecords: number;
  items: ScanManagerInvoiceItem[];
}

const useGetUnattachmentsDocumentsApi = () => {
  const call = useCallback(
    (params?: AttachDocumentRequest) =>
      new Promise<AttachDocumentResponse>((resolve, reject) => {
        axiosInstance
          .post<AttachDocumentResponse>(
            params?.isInvoices
              ? api.getScanInvoiceDataUrlFn(
                  parseInt(params?.companyId),
                  params?.uploadsOlderThan90Days ?? true
                )
              : api.getReceiptDataUrlFn(parseInt(params?.companyId || '')),
            params?.body
          )
          .then((data) => {
            resolve({
              ...data.data,
              items: data.data.items.map((item) => ({
                ...item,
                rowId: uuid(),
                selected: false,
              })),
            });
          })
          .catch((error) => {
            reject(error);
          });
      }),
    []
  );

  const { execute, isLoading, value, setValue } = useAsync(call, false, undefined, {
    totalRecords: 0,
    items: [],
  });

  return {
    getUnattachedDocuments: execute,
    areDocumentsLoading: isLoading,
    documentsResponse: value,
    setDocumentsResponse: setValue,
  } as const;
};

export default useGetUnattachmentsDocumentsApi;
